module.exports = __webpack_public_path__ + "media/images/oficinas/bella_vista-656ecdfda3a27e87ca625dca2a4f2b52.jpg";